import { apiFetch } from '../utils/apiFetch';

const apiUrl = process.env.REACT_APP_API_URL;

export async function getReviewsByChallengeId(challengeId) {
  try {
    const response = await apiFetch(`${apiUrl}/challenges/${challengeId}/reviews`, {
      method: 'GET',
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch reviews for challenge ${challengeId}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching challenge reviews:', error);
    throw error;
  }
}

export async function submitReview(challengeId, review) {
    console.log("Submitting review with body:", {
        challenge_id: challengeId,
        ...review
      });
      
    const response = await apiFetch(`${apiUrl}/challenges/${challengeId}/reviews`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        challenge_id: challengeId,  // must match the ID in URL
        setup_rating: review.setup_rating,
        difficulty_rating: review.difficulty_rating,
        overall_rating: review.overall_rating,
        comment: review.comment,
      }),
    });
  
    if (!response.ok) {
      const errorBody = await response.text();
      console.error('Review submission failed:', errorBody);
      throw new Error('Failed to submit review');
    }
  
    return await response.json();
  }
  